import { useState } from 'react';
import { HeaderParameters } from '../components';
import {
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Typography,
  Grid,
} from '@material-ui/core';
import { useProvider, useProviderFunctions } from 'contexts/ProviderContext';
import { useTheme } from '@material-ui/core/styles';
import CheckIcon from '@material-ui/icons/Check';
import DefaultSwitch from 'components/DefaultSwitch';
import mail from '_assets/parameters/mail.svg';
import SwitchStatus from 'components/SwitchStatus';

const enableSmsNotifications = false;

const notificationsStruct = [
  {
    enabled: true,
    text: (
      <Typography display="inline">
        Activer les notifications par{" "}
        <Typography component="span" display="inline" color="primary">
          e-mail
        </Typography>{" "}
        pour être tenu au courant de toutes nouvelles réservations.
      </Typography>
    ),
  },
  {
    enabled: enableSmsNotifications,
    text: <Typography display="inline">Activer les notifications par <Typography component="span" display="inline" color="primary">SMS</Typography> pour être tenu au courant de toutes nouvelles réservations.</Typography>
  },
  {
    enabled: true,
    text: (
      <Typography display="inline">
        Me notifier par{" "}
        <Typography component="span" display="inline" color="primary">
          e-mail
        </Typography>{" "}
        lors d’une modification de l’agenda par un collaborateur.
      </Typography>
    ),
  },
  { enabled: enableSmsNotifications, text: <Typography display="inline">Me notifier par <Typography component="span" display="inline" color="primary">SMS</Typography> lors d’une modification de l’agenda par un collaborateur.</Typography> },
  {
    enabled: true,
    text: (
      <Typography display="inline">
        Me notifier par{" "}
        <Typography component="span" display="inline" color="primary">
          e-mail
        </Typography>{" "}
        lors de la suppression d’un membre de l’équipe.
      </Typography>
    ),
  },
  { enabled: enableSmsNotifications, text: <Typography display="inline">Me notifier par <Typography component="span" display="inline" color="primary">SMS</Typography> lors de la suppression d’un membre de l’équipe.</Typography> },
  {
    enabled: true,
    text: (
      <Typography display="inline">
        Me notifier par{" "}
        <Typography component="span" display="inline" color="primary">
          e-mail
        </Typography>{" "}
        lors de la suppression d’une de mes entreprises.
      </Typography>
    ),
  },
  { enabled: enableSmsNotifications, text: <Typography display="inline">Me notifier par <Typography component="span" display="inline" color="primary">SMS</Typography> lors de la suppression d’une de mes entreprises.</Typography> },
];

const NotificationRow = (props) => {
  const { palette } = useTheme();

  return (
    <ListItem>
      <Grid container>
        <Grid item xs={8}>
          <ListItemText disableTypography={true}>{props.text}</ListItemText>
        </Grid>
        <Grid item xs={4}>
          <ListItemSecondaryAction style={{display:'flex'}}>
             <DefaultSwitch
                checked={props.checked}
                checkedIcon={CheckIcon}
                color={palette.primary.main}
                onChange={() => props.handleChange()}
                disabled={props.disabled}
            />
            <SwitchStatus status={props.checked}/>
          </ListItemSecondaryAction>
        </Grid>
      </Grid>
    </ListItem>
  );
};

const Notification = () => {
  const { notifications } = useProvider();
  const { editNotifications } = useProviderFunctions();

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (i, value) => {
    let tmp = [...notifications];
    tmp[i] = value?? !tmp[i];

    setIsSubmitting(true);
    editNotifications(tmp).then(() => {
      setIsSubmitting(false);
    });
  };

  return (
    <Grid container spacing={4} alignItems='center' style={{ marginTop: '16px' }}>
      <HeaderParameters image={mail} noMargin text='Notifications' />

      <Grid
        container
        item
        xs={12}
        justifyContent="center"
        spacing={3}
        style={{ marginTop: "2em" }}
      >
        <List>
          {notificationsStruct.map((n, i) => (
            n.enabled && <NotificationRow
              key={i}
              disabled={isSubmitting}
              text={n.text}
              checked={notifications[i]}
              handleChange={(value) => handleChange(i, value)}
            />
          ))}
        </List>
      </Grid>
    </Grid>
  );
};

export default Notification;
